export default __webpack_public_path__ + "static/media/technology-and-cleaning.99fdaa24.webp";